import { useMutation } from '@tanstack/react-query';

import type { LegalEntityMutationResponse } from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useLegalEntityActionMutation = () =>
  useMutation({
    mutationFn: (url: string) =>
      HttpClient.request<LegalEntityMutationResponse>({
        method: 'PUT',
        url,
      }),
  });
